import Header from 'pages/landing/common/Header/Header';
import ContactUs from '../ContactUs/ContactUs';
import Map from './Map/Map';
import Footer from 'pages/landing/common/Footer/Footer';
import Demo from './Demo/Demo';

function ContactUsPage() {
  return (
    <main>
      <Header role="default" />
      <ContactUs isSpecificPage />
      <Demo />
      <Map />
      <Footer />
    </main>
  );
}

export default ContactUsPage;
